import React from 'react'
import styles from './index.module.css'

const FeatureDescriptionCard = ({ icon = '⚡', description }) => {

    return (
        <div className={styles.featureCard}>
            <div>
                {icon}
            </div>
            <div>
                <span className={styles.featureStyle}>{description}</span>
            </div>
        </div>
    )
}

export default FeatureDescriptionCard